export default "/images/2b50f938a05d2d754713d9cf6137583a.avif";